module.exports = __webpack_public_path__ + "static/media/validate_step_collaborate.3ea44409.png";